import $ from 'jquery';
import plugin from '@core/plugins/lib';
import { onAvailable } from "@core/plugins/lib/selectors";


export const ELEMENT_SELECTOR = '[data-emit-on-dirty]';
export const PLUGIN_NAME = 'EmitOnDirty';


$(() => {
	onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		System.import(
			/* webpackChunkName: "plugin--emit-on-dirty" */ './plugin.js'
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});




// WEBPACK FOOTER //
// ./project/client/src/core/plugins/jquery__emit-on-dirty/index.js